'use client'

import { Flex } from '@radix-ui/themes';
import React from 'react';
import AuctionFilter from './AuctionFilter';
import AuctionSort from './_sort/AuctionSort';
import AuctionLotSelect from './AuctionLotSelect';
import AuctionFilterGroup from './AuctionFilterGroup';
import LotPagination from '../LotPagination';
import { useSearchParams } from 'next/navigation';
import { AUCTION_CATALOGUE_DEFAULT_PAGE_SIZE } from '@/lib/constants';

interface Props {
  allCategories: string[];
  totalLots: number;
}

const AuctionController = ({
  allCategories,
  totalLots
}: Props) => {
  const searchParams = useSearchParams();
  const page = parseInt(searchParams.get('page') || '1');
  const pageSize = parseInt(searchParams.get('pageSize') || AUCTION_CATALOGUE_DEFAULT_PAGE_SIZE.toString());

  return (
    <Flex direction="column" gap="3">
      <Flex
        direction="column"
        className="items-center w-full"
        gap="2"
      >
        <Flex justify="between" align="center" className="w-full flex-wrap gap-y-4 items-center">
          <AuctionFilter allCategories={allCategories} />

          <Flex gap="3" className="max-sm:flex-col w-max" align="center">
            <Flex align="center" gap="6">
              <AuctionSort />
              <AuctionLotSelect itemCount={totalLots} currentPage={page} pageSize={pageSize} />
            </Flex>
            <LotPagination />
          </Flex>
        </Flex>

        <Flex align="start" className="w-full flex-col gap-2 md:flex-row p-1 overflow-x-auto">
          <AuctionFilterGroup />
        </Flex>
      </Flex>
    </Flex>
  );
}

export default AuctionController
